import {LOAD_MENUS, MENU_ERROR, LOAD_OLD_MENUS} from './types';
import request from '../../../api/api';

function getDateString(date) {
    const dt = (('0' + date.getDate()).slice(-2));
    const month = (('0' + (date.getMonth() + 1)).slice(-2));

    return dt + '.' + month + '.' + date.getFullYear();
}

function getOldOrder(date, user, dispatch) {
    const dateString = getDateString(date);
    return request(
        '/v1/orders/food/get_orders_by_period' +
        '?object_id=' + user.id +
        '&object_type=' + user.type +
        '&period_end=' + dateString +
        '&period_begin=' + dateString
    ).then(data => {
            if (data.data.orders && data.data.orders.length > 0) {
                dispatch({
                    type: LOAD_OLD_MENUS,
                    payload: {
                        old: data.data.orders[0].saleTimes,
                        oldDate: data.data.orders[0].orderDate
                    }
                })
            }
        },
        error => {
            if (error.data && error.data.returnCode === 0) {
                dispatch({
                    type: LOAD_OLD_MENUS,
                    payload: {
                        old: [],
                        oldDate: ""
                    },
                });
                dispatch({
                    type: MENU_ERROR,
                    payload: error.data.error,
                });

                return null;
            } else return Promise.reject(error);
        }
    );
}

export default function (date, user) {
    return dispatch => {
        dispatch({
            type: LOAD_MENUS,
            payload: [],
        });
        return request(
            '/v1/orders/food/get_order_by_date' +
            '?object_id=' + user.id +
            '&object_type=' + user.type +
            '&order_date=' + getDateString(date)
        ).then(data => {
                dispatch({
                    type: LOAD_MENUS,
                    payload: data.data.saleTimes,
                });
            },
            error => {
                if (error.data && error.data.returnCode === 0) {
                    dispatch({
                        type: MENU_ERROR,
                        payload: error.data.error,
                    });
                    if (date <= new Date()) {
                        return getOldOrder(date, user, dispatch);
                    }
                }
                return Promise.reject(error);
            }
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/LoadMenus.js
 **/